import vue from 'vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

vue.component('phone-number-input', VuePhoneNumberInput);